export default {

    SET_USER: (state, payload) => {
        state.user = payload;
    },
    SET_MESSAGES_CHAT: (state, payload) => {
        state.messages_chat = payload;
    },
    SET_BADGE: (state, payload) => {
        state.badge = payload;
    },
    SET_BADGE_MESSAGES: (state, payload) => {
        state.badge.messages = payload;
    },
    SET_BADGE_ORDERS: (state, payload) => {
        state.badge.orders = payload;
    },
    SET_BADGE_ACTIVATIONS: (state, payload) => {
        state.badge.activations = payload;
    },
    SET_BRANDS: (state, payload) => {
        state.brands = payload;
    },
    SET_FEATURES: (state, payload) => {
        state.features = payload;
    },
    SET_VALUES: (state, payload) => {
        state.values = payload;
    },
    SET_CATEGORIES: (state, payload) => {
        state.categories = payload;
    },
    SET_CLASSES: (state, payload) => {
        state.classes = payload;
    },
    SET_PRODUCT_CARD: (state, payload) => {
        console.log(payload);
        state.product_card = payload;
    },
    SET_RESOURCES: (state, payload) => {
        console.log(payload);
        state.resources = payload;
    },
    SET_RESOURCE: (state, payload) => {
        state.resource = payload;
    },
    SET_ISLOGIN: (state, payload) => {
        console.log(payload);
        state.isLogin = payload;
    },
    SET_CHANGE: (state, payload) => {
        state.change = payload;
    },
    SET_PAGE: (state, payload) => {
        state.pageSet = payload;
    },
    SET_SEARCH_SET: (state, payload) => {
        state.searchSet = payload;
    },
    SET_CATEGORY_SELECT: (state, payload) => {
        state.categorySelect = payload;
    },
    SET_LANGUAGE: (state, payload) => {
        localStorage.setItem('language', payload);
        window.axios.defaults.headers.common['localization'] = payload;
        state.language = payload;
    },

    SET_BRAND: (state, payload) => {
        state.brand = payload;
    },
    SET_MENU: (state, payload) => {
        state.menu = payload;
    },

    SET_ROLE: (state, payload) => {
        state.role = payload;
    },

}